/**
 * PAPAPATTES — pastilles de couleur + variantes toujours visibles (fiche produit)
 *
 * - Les combos existants (details.pp-combo) restent en place (même HTML, mêmes radios, même JS de
 *   variantes) : on les garde ouverts et on masque leur résumé via CSS, pour afficher des boutons.
 * - Option « Couleur / Color » : une pastille est ajoutée si une couleur est reconnue dans le libellé ;
 *   sinon le bouton reste en texte seul (jamais de pastille fausse). Le nom reste toujours affiché.
 * - Ne touche à aucune valeur, aucun name/id : le choix de variante n'est pas modifié.
 */
(function () {
  var HEX = {
    noir: '#1f1f1f', blanc: '#ffffff', gris: '#9aa0a6', bleu: '#2f6fd0', rose: '#f4a6c0', rouge: '#d32f2f',
    vert: '#43a047', jaune: '#fdd835', orange: '#fb8c00', violet: '#7e57c2', marron: '#7a4b2a', beige: '#e3cfae',
    cafe: '#6f4e37', kaki: '#8a8d4c', marine: '#1f2f5a', or: '#d4af37', argent: '#c0c0c0', cyan: '#19c6d9',
    creme: '#f6ecd2', abricot: '#f9b778', peche: '#f6b79a', brun: '#8b5a2b', bordeaux: '#722f37',
    turquoise: '#26c6b9', menthe: '#98e0c0', lilas: '#c3a6e8', fuchsia: '#d81b8a', denim: '#4a6a9a',
    caramel: '#b9772f', moutarde: '#d9a521', corail: '#f2705a', saumon: '#f5937c', lavande: '#b9a7e0',
    anthracite: '#3b3f44', ivoire: '#f5f0dc', sable: '#d8c39a', chocolat: '#5a3a24', camel: '#b98a52'
  };
  // nuances / expressions : testées avant les couleurs de base (la plus longue d'abord)
  var PHRASES = [
    ['bleu marine', HEX.marine], ['bleu fonce', '#1f4a9a'], ['bleu clair', '#7fb2f0'], ['bleu ciel', '#87ceeb'],
    ['bleu saphir', '#0f52ba'], ['bleu sportif', '#1e6fe0'], ['bleu nordique', '#5b7fa8'], ['bleu gris', '#6f8aa6'],
    ['vert fonce', '#2e6b34'], ['vert clair', '#9ad29c'], ['vert militaire', '#5b6b3a'], ['vert fluorescent', '#7dff3a'],
    ['vert fluo', '#7dff3a'], ['vert kaki', HEX.kaki], ['vert herbe', '#7cb342'], ['vert gazon', '#5aa02c'],
    ['vert lac', '#2f8f7a'], ['vert menthe', HEX.menthe], ['vert turquoise', HEX.turquoise], ['vert matcha', '#9bb86b'],
    ['vert nordique', '#6b8f71'], ['vert fruit', '#8bc34a'], ['vert grenouille', '#5dbb3f'],
    ['gris fonce', '#5f6368'], ['gris clair', '#d0d3d6'], ['gris vert', '#8a9a8a'],
    ['rose framboise', '#c2185b'], ['rose vif', '#ec407a'], ['rose fonce', '#c2185b'], ['rose poudre', '#f3d1dc'],
    ['rose chair', '#f1c8b4'], ['rose cuir', '#d9a79a'], ['rouge vin', '#7b1e2b'], ['rouge rose', '#e57373'],
    ['rouge violace', '#a3315b'], ['marron fonce', '#4e2f1b'], ['marron clair', '#b68a63'], ['marron beige', '#b79c7a'],
    ['marron chocolat', HEX.chocolat], ['cafe fonce', '#4a3324'], ['jaune abricot', '#f6b73c'], ['blanc creme', HEX.creme],
    ['brun riz', '#cdb48a'], ['argent vintage', '#a8a8a0'], ['bois clair', '#d9b98a'], ['couleur bois', '#b98a52']
  ];
  var RAINBOW = 'linear-gradient(90deg,#e53935,#fb8c00,#fdd835,#43a047,#1e88e5,#8e24aa)';
  var RAINBOW_RE = /(multicolore|arc[- ]?en[- ]?ciel|lot de \d+ couleurs|ensemble de \d+ couleurs)/;

  function norm(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function colorsOf(label) {
    var t = ' ' + norm(label) + ' ';
    if (RAINBOW_RE.test(t)) return [RAINBOW];
    var found = [];
    var i;
    for (i = 0; i < PHRASES.length; i++) {
      if (t.indexOf(' ' + PHRASES[i][0] + ' ') > -1) {
        found.push({ at: t.indexOf(' ' + PHRASES[i][0] + ' '), hex: PHRASES[i][1] });
        t = t.replace(' ' + PHRASES[i][0] + ' ', ' ');
      }
    }
    Object.keys(HEX).forEach(function (k) {
      var at = t.indexOf(' ' + k + ' ');
      if (at > -1) found.push({ at: at, hex: HEX[k] });
    });
    found.sort(function (a, b) { return a.at - b.at; });
    return found.slice(0, 2).map(function (f) { return f.hex; });
  }

  function dot(hexes) {
    var s = document.createElement('span');
    s.className = 'pp-swatch-dot';
    s.setAttribute('aria-hidden', 'true');
    s.style.background = hexes[0].indexOf('gradient') > -1 ? hexes[0]
      : hexes.length > 1 ? 'linear-gradient(90deg,' + hexes[0] + ' 50%,' + hexes[1] + ' 50%)' : hexes[0];
    return s;
  }

  /* quantité : juste au-dessus du bouton Panier (l'input garde son attribut form=) */
  function moveQty() {
    var info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;
    var q = info.querySelector('.product-form__input--quantity, .product-form__quantity');
    var b = info.querySelector('product-form .product-form__buttons');
    if (!q || !b || q.nextElementSibling === b) return;
    b.parentNode.insertBefore(q, b);
  }
  function init() {
    moveQty();
    document.querySelectorAll('product-info variant-selects fieldset').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var isColor = legend && /couleur|color/i.test(legend.textContent);
      if (!isColor && fs.closest('variant-selects') && fs.querySelector('input[name]') && /couleur|color/i.test(fs.querySelector('input[name]').name)) { isColor = true; }
      var d = fs.querySelector('details.pp-combo');
      var MANY = 0; // au-delà, on garde le sélecteur déroulant (combo) plutôt que des dizaines de boutons
      if (d && !d.hasAttribute('data-pp-pinned')) {
        d.setAttribute('data-pp-pinned', '');
        if (fs.querySelectorAll('label.pp-tile').length > MANY) {
          d.classList.add('pp-combo--many');
        } else {
          d.open = true;
          new MutationObserver(function () { if (!d.open) d.open = true; })
            .observe(d, { attributes: true, attributeFilter: ['open'] });
        }
      }
      if (!isColor) { return; }
      var tiles = fs.querySelectorAll('label.pp-tile');
      var prices = {};
      tiles.forEach(function (l) {
        var p = l.querySelector('.pp-tile__price');
        if (p) prices[p.textContent.trim()] = 1;
      });
      var samePrice = Object.keys(prices).length <= 1;
      tiles.forEach(function (l) {
        if (samePrice) l.classList.add('pp-tile--noprice');
        if (l.querySelector('.pp-swatch-dot')) return;
        var name = l.querySelector('.pp-tile__name');
        if (!name) return;
        var hexes = colorsOf(name.textContent);
        if (hexes.length) name.insertBefore(dot(hexes), name.firstChild);
      });
      if (d && d.classList.contains('pp-combo--many')) {
        var trig = d.querySelector('.pp-combo__trigger');
        var val = d.querySelector('.pp-combo__value');
        var chk = fs.querySelector('input:checked + label .pp-swatch-dot');
        var old = trig && trig.querySelector('.pp-combo__dot');
        if (old) old.remove();
        if (trig && val && chk) {
          var dd = document.createElement('span');
          dd.className = 'pp-combo__dot';
          dd.setAttribute('aria-hidden', 'true');
          dd.style.background = chk.style.background;
          trig.insertBefore(dd, trig.firstChild);
        }
      }
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(init, 60); }
  document.addEventListener('DOMContentLoaded', function () {
    init();
    var host = document.querySelector('product-info');
    if (host) new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  });
})();
